import { formateDesignSystemDate } from 'utils/dateUtils'

import {
  PARTICIPANT_RISK_SORT_WEIGHTS,
  PARTICIPANT_STATUSES_VALUES,
  TLP_STATUSES_VALUES,
} from 'containers/SpearPhishingAgent/constants'

import { NAV_ACTIONS } from './navActions'

const NAV_ACTION_VALUES = Object.values(NAV_ACTIONS)

export const formatFullDate = (value) =>
  value
    ? formateDesignSystemDate(new Date(value), {
        withYear: true,
        monthFirst: true,
        withMinutes: true,
      })
    : ''

export const formatDayDate = (value) =>
  value
    ? formateDesignSystemDate(new Date(value), {
        withYear: true,
        monthFirst: true,
      })
    : ''

const toTime = (value) => {
  if (!value) return null
  const time = new Date(value).getTime()
  return Number.isNaN(time) ? null : time
}

export const getRowAfterPageCross = (action, rows) => {
  if (!NAV_ACTION_VALUES.includes(action) || !rows?.length) return null
  return action === NAV_ACTIONS.PREV ? rows[rows.length - 1] : rows[0]
}

/** Risk ordering for the participants table — highest risk first. */
export const getParticipantRiskWeight = ({ status, tlpStatus }) => {
  if (status === PARTICIPANT_STATUSES_VALUES.CLICKED) {
    return tlpStatus === TLP_STATUSES_VALUES.TRAINED
      ? PARTICIPANT_RISK_SORT_WEIGHTS.CLICKED_TRAINED
      : PARTICIPANT_RISK_SORT_WEIGHTS.CLICKED_UNTRAINED
  }

  if (status === PARTICIPANT_STATUSES_VALUES.OPENED) return PARTICIPANT_RISK_SORT_WEIGHTS.OPENED
  if (status === PARTICIPANT_STATUSES_VALUES.NOT_STARTED) {
    return PARTICIPANT_RISK_SORT_WEIGHTS.NOT_STARTED
  }
  if (status === PARTICIPANT_STATUSES_VALUES.REPORTED) return PARTICIPANT_RISK_SORT_WEIGHTS.REPORTED

  return PARTICIPANT_RISK_SORT_WEIGHTS.REPORTED + 1
}

export const sortParticipantsByRisk = (participants = []) =>
  [...participants].sort((a, b) => getParticipantRiskWeight(a) - getParticipantRiskWeight(b))

/* Column sorting inside the drawer. Unsorted keeps the risk order the roster arrives in. */
const PARTICIPANT_SORT_VALUE_BY_KEY = {
  name: ({ name }) => (name || '').toLowerCase(),
  status: (participant) => getParticipantRiskWeight(participant),
  tlpStatus: ({ tlpStatus }) => tlpStatus || '',
  trainingReminderSentDates: ({ trainingReminderSentDates }) =>
    toTime(trainingReminderSentDates?.at(-1)) ?? 0,
  sentLanguage: ({ sentLanguage }) => sentLanguage || '',
  lastUserActivityAt: ({ lastUserActivityAt }) => toTime(lastUserActivityAt) ?? 0,
}

export const sortParticipants = (participants, sort) => {
  const sorted = [...(participants || [])]
  const getValue = sort?.key && PARTICIPANT_SORT_VALUE_BY_KEY[sort.key]

  if (!getValue || !sort.direction) return sorted

  const factor = sort.direction === 'asc' ? 1 : -1

  return sorted.sort((a, b) => {
    const left = getValue(a)
    const right = getValue(b)

    if (typeof left === 'string') return left.localeCompare(right) * factor
    return (left - right) * factor
  })
}
